<template>
    <div class="page">
        <section class="blk1 fz32">
            <div>Please enter your cell phone number  for login</div>
        </section>



        <div class="formbox blk3">
            <section>
                <input class="input-block" v-model="mobile" type="number" name="mobile" placeholder="Insert Mobitel phone number ">
            </section>
          <section class="blk1 fz32">
            <div>Rs 14.40+ taxes per day / Daily auto renewal</div>
          </section>
       <!--     <section>
                <input class="input-block" v-model="passwd" type="password" name="passwd" placeholder="Inster Your password">
            </section>-->
            <section>
                <div class="btn btn-block" @click="_loginAction">Login</div>
            </section>


          <section>
            <a href="https://www.mobitel.lk/games-apps#ChallengeME">
              <div class="btn btn-block" >Terms and Conditions/ Deactivation method</div>
            </a>
          </section>
        </div>

     <!--   <section class="mt30">
            <p class="mt10">Don't have Account? <a href="">Click here</a></p>
            <p>Type QM send sms to 1234 </p>
            <p class="mt20">Forget your password? <a href="">Click here</a></p>
        </section>-->

<!--        <Footer></Footer>-->
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Footer from './Footer'
export default {
    name: 'Loin',
    components: {Footer},
    data(){
        return{
            mobile: '',
            passwd: ''
        }
    },
    computed: {
        ...mapState(['langMap','lang'])
    },
    created(){
        if ( localStorage.localUuid &&
             localStorage.localToken &&
             localStorage.localMisisdn ) {

            this.$router.push('/Ucenter');
        }
    },
    methods: {
        ...mapActions(['setUserInfo']),
        // 登录
        _loginAction(){
            // this.$messagebox.confirm('确认删除吗？', 'tips', {confirmButtonText:'ok', cancelButtonText:'cancel'});
            // return;
            let reqData = {mobile: this.mobile, password: this.passwd}
            Utils.$ajax({
                type: 'post',
                url: '/login/login',
                data: reqData,
            }).done(res=>{
              if(res.code==0){
                this.setUserInfo(res.data);
                localStorage.localUuid = res.data.uuid;
                localStorage.localToken = res.data.token;
                localStorage.localMisisdn = res.data.mobile;
                this.$router.push('/Ucenter');
              }else if(res.code== 40001){
                location.replace("https://services.mobitel.lk/MCCPortal/service/?compId=CHALLENGEME&reqType=ACTIVE&servId=CHME");
              }
              else{
                this.$toast(res.msg);
              }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        padding: 0 1em;
    }
    .blk2{
        margin-top: rem(30);
        i{
            display: inline-block;
            width: 1.2em;
            line-height: 1.2em;
            text-align: center;
            border-radius: 50%;
            background-color: rgba(255,255,255,.3);
            vertical-align: middle;
            margin-right: .8em;
        }
    }
    .blk3{
        margin-top: rem(46);
        section{
            margin-top: rem(34);
            &:first-child{
                margin-top: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue